export default {
	title: 'self_test',
	components: [{ title: 'self_test', component: 'self_test' }],
};
